<template>
  <footer class="footer_guide">
    <a href="javascript:;" class="guide_item" :class="{on:isCurrent('payment')}" @click="gotoPath('/payment')">
      <span class="item_icon">
        <i class="iconImg icon-index" :class="{onImg:isCurrent('payment')}"></i>
      </span>
      <span>缴费查询</span>
    </a>
    <a href="javascript:;" class="guide_item" :class="{on:isCurrent('autpayment')}" @click="gotoPath('/autpayment')">
      <span class="item_icon">
        <i class="iconImg icon-autpayment" :class="{onImg:isCurrent('autpayment')}"></i>
      </span>
      <span>缴费中心</span>
    </a>
    <a href="javascript:;" class="guide_item" :class="{on:isCurrent('reportrepair')}" @click="gotoPath('/reportrepair')">
      <span class="item_icon">
        <i class="iconImg icon-repair" :class="{onImg:isCurrent('reportrepair')}"></i>
      </span>
      <span>供热报修</span>
    </a>
    <a href="javascript:;" class="guide_item" :class="{on:isCurrent('profile')}" @click="gotoPath('/profile')">
      <span class="item_icon">
        <i class="iconImg icon-profile" :class="{onImg:isCurrent('profile')}"></i>
      </span>
      <span>我的</span>
    </a>
  </footer>
</template>

<script>
	export default {
	  methods: {
	    gotoPath(path){
        this.$router.push({
          path:path,
          name:path.substring(1)
        })
      },
      isCurrent(name){
        return this.$route.name === name
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .footer_guide
    top-border-1px(#e7e7e7)
    position fixed
    z-index 100
    left 0
    right 0
    bottom 0
    background-color #fff
    width 100%
    height 112px
    display flex
    .guide_item
      display flex
      flex 1
      text-align center
      flex-direction column
      align-items center
      margin 5px
      padding 20px 0px
      color #888888
      &.on
        color #ff6d02
      span
        font-size 24px
        margin-top 2px
        margin-bottom 2px
        .iconImg
          display: -webkit-inline-flex;
          display: inline-flex;
        .icon-index
          width 36px
          height 38px
          background url("./images/index.png") no-repeat center
          background-size 100% 100%;
          &.onImg
            width 36px
            height 38px
            background url("./images/onIndex.png") no-repeat center
            background-size 100% 100%;
        .icon-autpayment
          width 43px
          height 37px
          background url("./images/Payment.png") no-repeat center
          background-size 100% 100%;
          &.onImg
            width 43px
            height 37px
            background url("./images/onPayment.png") no-repeat center
            background-size 100% 100%;
        .icon-profile
          width 34px
          height 37px
          background url("./images/Profile.png") no-repeat center
          background-size 100% 100%;
          &.onImg
            width 34px
            height 37px
            background url("./images/onProfile.png") no-repeat center
            background-size 100% 100%;
        .icon-repair
          width 34px
          height 37px
          background url("./images/repair.png") no-repeat center
          background-size 100% 100%;
          &.onImg
            width 34px
            height 37px
            background url("./images/onrepair.png") no-repeat center
            background-size 100% 100%;
</style>



// WEBPACK FOOTER //
// src/components/FooterNav/FooterNav.vue